<script setup lang="ts">
import { addDays } from 'date-fns'
import { to_dd_MMMM } from '@/utils/helpers';

const storeU = useUtilisateurStore()
const selectedDay = defineModel<Date>()
const showDatePicker = ref(false)

function previousDay() {
  const newDate = addDays(selectedDay.value ?? new Date(), -1)
  if (newDate.getFullYear() === storeU.annéeSélectionnée) {
    selectedDay.value = newDate
  }
}
function nextDay() {
  const newDate = addDays(selectedDay.value ?? new Date(), 1)
  if (newDate.getFullYear() === storeU.annéeSélectionnée) {
    selectedDay.value = newDate
  }
}
function selectDay(date: Date) { selectedDay.value = date }

function allowedDates(val : any) {
  return val.getFullYear() === storeU.annéeSélectionnée
}

watch(() => storeU.annéeSélectionnée, (newYear) => {
  if (selectedDay.value === undefined) {
    const today = new Date()
    selectedDay.value = new Date(newYear, today.getMonth(), today.getDate())
  }
  else if (selectedDay.value.getFullYear() !== newYear) {
    selectedDay.value = new Date(newYear, selectedDay.value.getMonth(), selectedDay.value.getDate())
  }
})
</script>

<template>
  <div class="pl-1">
    <v-card class="d-flex align-center" elevation="2">
      <v-icon color="primary" icon="M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H18V1M17,12H12V17H17V12Z" class="mt-1 ml-2 mr-1 pt-2 pb-2" size="48"/>
      <v-btn color="primary" variant="tonal" elevation="2" size="40" class="me-1" @click="previousDay">
        <v-icon class="text-capitalize" color="primary" icon="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" size="24"/>
      </v-btn>
      <v-btn color="primary" elevation="2" class="me-1" rounded="lg" variant="tonal" min-width="250" @click="showDatePicker = true">
        <span class="text-capitalize" color="primary">{{ to_dd_MMMM(selectedDay ?? new Date()) }}</span>
      </v-btn>
      <v-btn color="primary" variant="tonal" elevation="2" size="40" class="me-1" @click="nextDay">
        <v-icon class="text-capitalize" color="primary" icon="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" size="24"/>
      </v-btn>
      <v-divider vertical class="my-2 mx-1"/>
      <YearSelector class="me-1"/>
    </v-card>
  </div>

  <v-dialog v-model="showDatePicker" max-width="360px">
    <v-card rounded="xl" class="overflow-hidden pa-0">

      <div class="day-picker-header">
        <div class="text-overline day-picker-header__label">Journée sélectionnée</div>
        <div class="text-h5 font-weight-bold day-picker-header__date">
          {{ to_dd_MMMM(selectedDay ?? new Date()) }}
        </div>
        <v-btn
          density="comfortable"
          icon="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
          variant="text"
          class="day-picker-header__close"
          color="white"
          @click="showDatePicker = false"
        />
      </div>

      <v-date-picker
        v-model="selectedDay"
        :first-day-of-week="1"
        show-adjacent-months
        :allowed-dates="allowedDates"
        hide-header
        color="primary"
        width="100%"
        elevation="0"
        @update:model-value="selectDay"
      />

      <v-card-actions class="px-4 pb-4 pt-1 gap-2">
        <v-spacer />
        <v-btn variant="text" rounded="lg" @click="showDatePicker = false">Annuler</v-btn>
        <v-btn color="primary" variant="flat" rounded="lg" @click="showDatePicker = false">OK</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<style scoped>
.day-picker-header {
  position: relative;
  background: rgb(var(--v-theme-primary));
  padding: 20px 24px 18px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.day-picker-header__label {
  color: rgba(255, 255, 255, 0.75);
  letter-spacing: 0.1em;
  font-size: 0.7rem;
}
.day-picker-header__date {
  color: #fff;
}
.day-picker-header__close {
  position: absolute;
  top: 8px;
  right: 8px;
  opacity: 0.8;
}
.day-picker-header__close:hover {
  opacity: 1;
}
</style>
